module.exports = __webpack_public_path__ + "img/3ac553ea77911248ab4519bca020e0aa2891a6c6.a8046e03.png";